import { Layout } from '@/components/Layout/Layout.tsx';
import { CustomerAccountsContainer } from '@/features/accounts/CustomerAccountsContainer.tsx';
import { InvoicesContainer } from '@/features/invoices/InvoicesContainer.tsx';
import { Login } from '@/features/login/Login.tsx';
import { LoginLayout } from '@/features/login/LoginLayout.tsx';
import { RequireAuth } from '@/features/login/RequireAuth.tsx';
import { LostCredentials } from '@/features/LostCredentials/LostCredentials';
import { MeansOfPaymentsContainer } from '@/features/means-of-payments/MeansOfPaymentsContainer.tsx';
import { OnBoardingRouter } from '@/features/OnBoarding/OnBoardingRouter.tsx';
import PartnerInfo from '@/features/PartnerInfo/PartnerInfo.tsx';
import {
  ResetCredentials,
  ResetCredentialsFail,
  ResetCredentialsSuccess,
} from '@/features/ResetCredentials/ResetCredentials.tsx';
import { createBrowserRouter } from 'react-router';

export const Router = createBrowserRouter([
  {
    Component: Layout,
    children: [
      {
        path: `/`,
        index: true,
        Component: () => (
          <RequireAuth>
            <CustomerAccountsContainer />
          </RequireAuth>
        ),
      },
      {
        path: `/customer-accounts`,
        Component: () => (
          <RequireAuth>
            <CustomerAccountsContainer />
          </RequireAuth>
        ),
      },
      {
        path: `/partner-info`,
        Component: () => (
          <RequireAuth>
            <PartnerInfo />
          </RequireAuth>
        ),
      },
      {
        path: `/invoices`,
        Component: () => (
          <RequireAuth>
            <InvoicesContainer />
          </RequireAuth>
        ),
      },
      {
        path: `/means-of-payments`,
        Component: () => (
          <RequireAuth>
            <MeansOfPaymentsContainer />
          </RequireAuth>
        ),
      },
    ],
  },
  {
    Component: LoginLayout,
    children: [
      {
        path: `/login`,
        Component: Login,
      },
      {
        path: `/lost-credentials`,
        Component: LostCredentials,
      },
      {
        path: '/reset-credentials',
        Component: () => (
          <RequireAuth redirect={'/reset-credentials/invalid'}>
            <ResetCredentials />
          </RequireAuth>
        ),
      },
      {
        path: '/reset-credentials/invalid',
        Component: ResetCredentialsFail,
      },
      {
        path: '/reset-credentials/success',
        Component: ResetCredentialsSuccess,
      },
    ],
  },
  ...OnBoardingRouter,
]);
